import { useEffect } from "react";
import { useLocation } from "react-router";

export function useScrollToSection() {
	const location = useLocation();

	useEffect(() => {
		if (!location.state) return;

		const timer = setTimeout(() => {
			scrollToSection(location.state.section);
		}, 750);

		return () => clearTimeout(timer);
	}, []);
}

export function scrollToSection(section: string): void {
	const item = document.getElementById(section);
	if (item) {
		item.scrollIntoView({ behavior: "smooth", block: "start" });
	}
}
